import { SvgIcon, SvgIconProps } from '@mui/material';

import './ccf-inbound-assignment-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfInboundAssignmentIconProps extends SvgIconProps {}

/**
 * Function is used to diaply inbound assignment icon
 * @param props -CcfInboundAssignmentProps
 * @returns svg icons of inbound assignment
 * @example <CcfInboundAssignment/>
 */
export function CcfInboundAssignmentIcon(props: CcfInboundAssignmentIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Group_120844" data-name="Group 120844" transform="translate(0.52 1.051)">
        <g id="Group_120782" data-name="Group 120782" transform="translate(0)">
          <g id="btn_inbound" transform="translate(0.48 -0.051)">
            <path id="Path_25429" data-name="Path 25429" d="M3847.5-3110.5v4.182h12.96v-4.182" transform="translate(-3847.501 3117.274)" fill="none" stroke="#526b7a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            <path id="Polygon_90" data-name="Polygon 90" d="M3.7,1.067a1,1,0,0,1,1.6,0L7.8,4.4A1,1,0,0,1,7,6H2a1,1,0,0,1-.8-1.6Z" transform="translate(11 9.503) rotate(180)" fill="#526b7a" />
            <path id="Path_25436" data-name="Path 25436" d="M4730.5-2433.75v-7.753" transform="translate(-4724 2441.503)" fill="none" stroke="#526b7a" strokeLinecap="round" strokeWidth="2" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfInboundAssignmentIcon;
